<template>
  <div class="">
    <div class="col-12 mb-primary">
      <div class="card border-0 h-100">
        <div class="card-header p-primary bg-transparent">
          <h5 class="card-title d-inline-block mb-0">{{ $t("task") }}</h5>
        </div>
        <!-- <app-overlay-loader v-if="preloader" /> -->
        <div class="card-body">
          <form
            class="mb-0"
            ref="form"
            :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
          >
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("title") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-9"
                type="text"
                v-model="task.title"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("description") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-9"
                type="textarea"
                v-model="task.description"
                :required="true"
              />
            </div>

            <div class="mt-5 action-buttons" style="text-align: end">
              <app-load-more
                :preloader="preloader"
                :label="$t('submit')"
                type="submit"
                class-name="btn btn-primary mr-2 text-center"
                @submit="updateTask"
              />
              <!-- <button
                type="submit"
                class="btn btn-primary mr-2"
                @click.prevent="updateTask"
              >
                {{ $t("submit") }}
              </button> -->
              <button
                type="submit"
                class="btn btn-secondary"
                @click.prevent="clear"
              >
                {{ $t("clear") }}
              </button>
            </div>
          </form>
        </div>

        <div class="card-body">
          <form
            ref="form"
            data-url="/crud"
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
          >
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("assigned_supplier") }}</label>
                  <table class="table">
                    <tr>
                      <td>1</td>
                      <td>Quality Management</td>
                      <td>Supervisor</td>
                      <td>2021-05-04 07:00</td>
                      <td>2021-05-04 07:00</td>
                      <td>
                        <button class="btn btn-primary btn-sm">view</button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div> -->

            <!-- <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <label>{{ $t("site_list") }}</label>
                <table class="table">
                  <tr>
                    <th>S.No</th>
                    <th>Title</th>
                    <th>Action</th>
                  </tr>
                  <tr v-for="(task, index) in tasks" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ task.title }}</td>
                    <td>
                      <a
                        href="#"
                        v-on:click="viewTask(task.id)"
                        class="btn btn-primary btn-sm"
                        >view</a
                      >
                    </td>
                  </tr>
                </table>
              </div>
            </div> -->
          </form>
        </div>
      </div>
    </div>

    <company-upload
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import {
  COMPANY_JOB_SITE_TASK_SHOW,
  COMPANY_JOB_SITE_TASK_UPDATE,
} from "../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper.js";

export default {
  name: "FormGrid",
  mixins: [FormMixin],
  props: ["id"],
  data() {
    return {
      isAddEditModalActive: false,
      preloader: false,
      task: {},
    };
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {
        gender: "male",
      };
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
      this.fieldStatus = {
        isSubmit: false,
      };
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      this.isAddEditModalActive = false;
    },
    addNewSite() {
      this.addSite();
    },
    popSite(index) {
      this.site.splice(index, 1);
    },
    getTask() {
      axiosGet(COMPANY_JOB_SITE_TASK_SHOW + "/" + this.id)
        .then((res) => {
          this.task = res.data;
        })
        .catch((error) => {
          
        });
    },
    updateTask() {
      this.preloader = true;
      axiosPost(COMPANY_JOB_SITE_TASK_UPDATE, this.task)
        .then((res) => {
          
          this.$toastr.s(res.data.type);
        })
        .catch((error) => {
          
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    // let nsplit = split[8].split("?");
    this.getTask();
  },
};
</script>
